<h2 mat-dialog-title>Confirmation Dialog</h2>
<mat-dialog-content>
  Would you like to return to the search mask to perform a search with the newly selected scopes?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">Confirm</button>
</mat-dialog-actions>
